/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ProjectClientAction = {
    AcceptProposal: 'ACCEPT_PROPOSAL',
    AcceptAmendment: 'ACCEPT_AMENDMENT',
    AddPurchaseOrder: 'ADD_PURCHASE_ORDER',
    PrepayFixedPriceMission: 'PREPAY_FIXED_PRICE_MISSION',
    CompleteMission: 'COMPLETE_MISSION',
    LetFreelanceAppraisal: 'LET_FREELANCE_APPRAISAL',
    PayMission: 'PAY_MISSION',
    CompleteLot: 'COMPLETE_LOT',
    ApproveExpense: 'APPROVE_EXPENSE',
    ApproveExpenseBatch: 'APPROVE_EXPENSE_BATCH',
    ReviewExpense: 'REVIEW_EXPENSE',
    PayExpense: 'PAY_EXPENSE'
} as const;
export type ProjectClientAction = typeof ProjectClientAction[keyof typeof ProjectClientAction];


export function instanceOfProjectClientAction(value: any): boolean {
    for (const key in ProjectClientAction) {
        if (Object.prototype.hasOwnProperty.call(ProjectClientAction, key)) {
            // @ts-ignore
            if (ProjectClientAction[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ProjectClientActionFromJSON(json: any): ProjectClientAction {
    return ProjectClientActionFromJSONTyped(json, false);
}

export function ProjectClientActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectClientAction {
    return json as ProjectClientAction;
}

export function ProjectClientActionToJSON(value?: ProjectClientAction | null): any {
    return value as any;
}

